import styles from './Recruit.module.scss'
import Button from 'components/commons/Button/Button'
import BasicTitle from 'components/commons/BasicTitle/BasicTitle'
import { useRef, useEffect } from 'react'
import { gsap, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const tweenVars: gsap.TweenVars = {
  y: '50',
  duration: 0.5,
  opacity: 0,
  ease: Power1.easeOut,
}

interface RecruitProps {
  tagType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' // 追加
}

const Recruit: React.FC<RecruitProps> = ({ tagType = 'h3' }) => {
  const timeline = gsap.timeline()
  const button = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from('.Recruit_txt', tweenVars, 0.6).from('.Recruit_btn', tweenVars, 0.9)

    ScrollTrigger.create({
      animation: timeline,
      trigger: '.Recruit_txt',
      start: 'top 90%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  const sectionTitle = {
    title: 'Recruit',
    sub_title: '採用情報',
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.main}>
          <BasicTitle sectionTitle={sectionTitle} tagType={tagType} />
          <div className={`${styles.readtxt} Recruit_txt`}>
            Aitriaで
            <br className={styles.u_sp} />
            一緒に働く仲間を
            <br />
            募集しています。
          </div>
          <div className={`${styles.btn} Recruit_btn`} ref={button}>
            <Button text="採用情報" href="https://aitria.careers/" isExternal />
          </div>
        </div>
        <picture className={styles.recruitimg}>
          <source srcSet="/images/img/recruit_pc.webp" media="(min-width: 720px)" />
          <img src="/images/img/recruit_sp.webp" alt="採用画像" />
        </picture>
      </div>
    </section>
  )
}

export default Recruit
